"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var initPaymentErrorStyles = styles_1.makeStyles(function (_a) {
    var typography = _a.typography;
    return ({
        translation: {
            minHeight: '50px',
            lineHeight: '40px',
            fontWeight: typography.fontWeightLight,
            display: 'block',
        },
    });
}, { name: 'Gql_InitPaymentError' });
exports.default = initPaymentErrorStyles;
